import { useGeneralStore } from '@/stores/generalStore';
import { useJourneyStore } from '@/stores/journeyStore';

// Initialize deferredPrompt for use later to show browser install prompt.
let deferredPrompt;

async function addBeforeInstallPromptListener() {
  window.addEventListener('beforeinstallprompt', async (e) => {
    console.log(`'beforeinstallprompt' event was fired.`);
    // Prevent the mini-infobar from appearing on mobile
    // e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    // Update UI to notify the user they can install the PWA IF it hasn't been dismissed before AND a critical user journey has been completed
    showInstallPromotionIfWarranted();
  });
}

function addUserJourneyCompletedListener() {
  //Listener for user journey completion. Necessary because install prompt is delayed until a certain journey has been completed.
  window.addEventListener('userJourneyCompleted', () => {
    console.log(`'userJourneyCompleted' event was fired.`);
    //Check for stashed beforeInstallPrompt event
    if (!deferredPrompt) {
      console.log('No stashed beforeInstallPrompt found');
      return;
    }
    // Update UI to notify the user they can install the PWA IF it hasn't been dismissed before AND a critical user journey has been completed
    showInstallPromotionIfWarranted();
  });
}

const showInstallPromotionIfWarranted = async function () {
  const dismissed = await pwaInstallationWasDismissedLocalStorage();
  const journeyAchieved = criticalUserJourneyCompleted();

  if (!dismissed && journeyAchieved && appOpenInBrowser()) {
    //Also checks if app is opened is browser to prevent showing the install prompt in installed pwa window
    console.log('Showing pwa install prompt');
    showInstallPromotion();
  }
};

const addEventListenersForPwaInstallation = function () {
  //Adds listeners necessary for custom handling of install prompt
  addBeforeInstallPromptListener();
  addUserJourneyCompletedListener();
};

const showInstallPromotion = function () {
  const generalStore = useGeneralStore();
  generalStore.showPwaInstallPrompt = true;
};

const hideInstallPromotion = function () {
  const generalStore = useGeneralStore();
  generalStore.showPwaInstallPrompt = false;
};

const criticalUserJourneyCompleted = function () {
  //Returns true if a critical user journey has been completed, in this case the viewing of trial info and the return to the trial list
  const journeyStore = useJourneyStore();
  return journeyStore.completedUserJourneys?.viewedTrialAndReturnedToList;
};

const appOpenInBrowser = function () {
  return window.matchMedia('(display-mode: browser)').matches;
};

const installPromptButtonClicked = async function () {
  // Hide the app provided install promotion
  hideInstallPromotion();
  // Show the install prompt
  deferredPrompt.prompt();
  // Wait for the user to respond to the prompt
  const { outcome } = await deferredPrompt.userChoice;
  // Optionally, send analytics event with outcome of user choice
  console.log(`User response to the install prompt: ${outcome}`);

  //Store user answer
  saveInstallResponseToLocalStorage(outcome);

  // We've used the prompt, and can't use it again, throw it away
  deferredPrompt = null;
};

const saveInstallResponseToLocalStorage = async function (response: string) {
  localStorage.setItem('pwaInstallResponse', response);
};

async function pwaInstallationWasDismissedLocalStorage() {
  const pwaInstallResponse = localStorage.getItem('pwaInstallResponse');
  return pwaInstallResponse === 'dismissed';
}

export default {
  addEventListenersForPwaInstallation,
  showInstallPromotion,
  hideInstallPromotion,
  installPromptButtonClicked,
  saveInstallResponseToLocalStorage,
  pwaInstallationWasDismissedLocalStorage,
};
